import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const GridSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.89336 1.22578L2.02656 2.80721V4.45078C2.02656 4.74073 1.79151 4.97578 1.50156 4.97578C1.21161 4.97578 0.976562 4.74073 0.976562 4.45078V2.42578C0.976562 2.19834 1.12301 1.99677 1.33932 1.92648L6.57571 0.224957C6.67598 0.192376 6.78075 0.175781 6.88617 0.175781H11.0682C11.1727 0.175781 11.2766 0.19209 11.3761 0.224118L16.6625 1.92604C16.8794 1.9959 17.0266 2.19782 17.0266 2.42578V4.45078C17.0266 4.74073 16.7915 4.97578 16.5016 4.97578C16.2116 4.97578 15.9766 4.74073 15.9766 4.45078V2.8083L11.0611 1.22578H6.89336Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.89336 6.02571L2.02656 7.60713V9.25071C2.02656 9.54066 1.79151 9.77571 1.50156 9.77571C1.21161 9.77571 0.976562 9.54066 0.976562 9.25071V7.22571C0.976562 6.99827 1.12301 6.79669 1.33932 6.72641L6.57571 5.02488C6.67598 4.9923 6.78075 4.97571 6.88617 4.97571H11.0682C11.1727 4.97571 11.2766 4.99202 11.3761 5.02404L16.6625 6.72597C16.8794 6.79583 17.0266 6.99774 17.0266 7.22571V9.25071C17.0266 9.54066 16.7915 9.77571 16.5016 9.77571C16.2116 9.77571 15.9766 9.54066 15.9766 9.25071V7.60822L11.0611 6.02571H6.89336Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5016 3.92567H1.50156V2.87567H16.5016V3.92567Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5016 8.72578H1.50156V7.67578H16.5016V8.72578Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3336 0.475708C11.6235 0.475708 11.8586 0.710759 11.8586 1.00071V7.11374L15.5055 19.6036C15.5729 19.8343 15.475 20.0812 15.2679 20.2031C15.0608 20.3251 14.7973 20.2908 14.6283 20.1199L8.6283 14.0538C8.4244 13.8476 8.42623 13.5152 8.63237 13.3113C8.83852 13.1074 9.17092 13.1093 9.37482 13.3154L13.9163 17.9069L10.8086 7.2639V1.00071C10.8086 0.710759 11.0436 0.475708 11.3336 0.475708Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.73269 0.475708C6.44274 0.475708 6.20769 0.710759 6.20769 1.00071V7.1125L2.49829 19.6012C2.43007 19.8309 2.52603 20.0777 2.73151 20.2009C2.93699 20.3242 3.19986 20.2927 3.37038 20.1243L12.3704 11.24C12.5767 11.0363 12.5789 10.7039 12.3752 10.4976C12.1715 10.2912 11.8391 10.2891 11.6327 10.4928L4.08643 17.9421L7.25769 7.26514V1.00071C7.25769 0.710759 7.02264 0.475708 6.73269 0.475708Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.63033 10.3795C5.83536 10.1745 6.16777 10.1745 6.37279 10.3795L9.37279 13.3795C9.57782 13.5845 9.57782 13.9169 9.37279 14.1219C9.16777 14.327 8.83536 14.327 8.63033 14.1219L5.63033 11.1219C5.42531 10.9169 5.42531 10.5845 5.63033 10.3795Z"
        fill={color}
      />
    </svg>
  );
};

export { GridSvg };
